import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'json-select',
  templateUrl: './json-select.component.html',
  styleUrls: ['./json-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonSelectComponent),
      multi: true,
    },
  ],
})
export class JsonSelectComponent implements ControlValueAccessor {
  @Input() public disabled: boolean;
  @Input() public placeholder: string;
  @Input() public path: string;
  @Input() public name: string;
  @Input() public options: any[];

  onChange: (_: any) => void = (_: any) => {};

  value: any;
  json: any;

  constructor(public sharedService: SharedService) {
    this.disabled = false;
  }
  writeValue(obj: any): void {
    this.value = _.get(obj, this.path);
    this.json = obj || {};
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  updateChanges() {
    if (this.value) {
      const change = _.set({}, this.path, this.value);
      this.json = _.merge(this.json, change);
    } else {
      _.unset(this.json, this.path);
    }

    this.onChange(this.json);
  }
}
